<button class="trash btn btn-link" (click)="removeQuestion()" [disabled]="isDeleting" readonly="true"><fa-icon [icon]="fa.trash"></fa-icon></button>